
const tr = {
  en: {
    rmConfPrompt : 'Remove {{brand}} account {{msisdn}} and its related subscriptions?',
    note: 'Please note. This does not cancel your subscriptions from {{brand}}{{msisdn}}.',

    confirmBtnTxt: 'Confirm',
    cancelBtnTxt: 'Cancel'
  },
  zh: {
    rmConfPrompt: '確認移除{{brand}}帳戶{{msisdn}}及其相關服務?',
    note: '請留意，移除帳戶並不會將您{{brand}}帳戶{{msisdn}}所訂購的服務取消。',
    confirmBtnTxt: '確定',
    cancelBtnTxt: '取消'
  }
}

export default tr;
